import { put, call, fork, takeLatest, select } from 'redux-saga/effects'
import apiClient from 'admin/api/apiClient'
import { notifyError, notifySuccess } from 'shared/sharedMethod'
import { insertEmptyRow, insertRows } from 'shared/itemHelper'
import { v4 as uuidv4 } from 'uuid'
import * as suiteFolderDuck from 'admin/store/ducks/productSuiteFolder.duck'

// Actions
export const actionTypes = {
  CREATE_PRODUCT_SUITE_ITEM: 'productSuiteItem/CREATE_PRODUCT_SUITE_ITEM',
  FETCH_PRODUCT_SUITE_ITEMS: 'productSuiteItem/FETCH_PRODUCT_SUITE_ITEMS',
  FETCH_PRODUCT_SUITE_ITEM: 'productSuiteItem/FETCH_PRODUCT_SUITE_ITEM',
  UPADE_PRODUCT_SUITE_ITEM: 'productSuiteItem/UPADE_PRODUCT_SUITE_ITEM',
  DELETE_PRODUCT_SUITE_ITEM: 'productSuiteItem/DELETE_PRODUCT_SUITE_ITEM',

  PRODUCT_SUITE_ITEM_CREATED: 'productSuiteItem/PRODUCT_SUITE_ITEM_CREATED',
  PRODUCT_SUITE_ITEMS_LOADED: 'productSuiteItem/PRODUCT_SUITE_ITEMS_LOADED',
  PRODUCT_SUITE_ITEM_LOADED: 'productSuiteItem/PRODUCT_SUITE_ITEM_LOADED',
  PRODUCT_SUITE_ITEM_UPDATED: 'productSuiteItem/PRODUCT_SUITE_ITEM_UPDATED',
  PRODUCT_SUITE_ITEM_DELETED: 'productSuiteItem/PRODUCT_SUITE_ITEM_DELETED',

  INSERT_EMPTY_ROW: 'productSuiteItem/INSERT_EMPTY_ROW',
  DELETE_ROW: 'productSuiteItem/DELETE_ROW',
  INSERT_ROWS: 'productSuiteItem/INSERT_ROWS'
}

const initialState = {
  productSuiteItem: null,
  productSuiteItems: null
}

// Reducer
export function reducer (state = initialState, action) {
  switch (action.type) {
    case actionTypes.CREATE_PRODUCT_SUITE_ITEM:
      return { ...state, productSuiteItem: action.payload }
    case actionTypes.FETCH_PRODUCT_SUITE_ITEMS:
      return { ...state, productSuiteItems: null }
    case actionTypes.FETCH_PRODUCT_SUITE_ITEM:
      return { ...state, productSuiteItem: null }
    case actionTypes.UPADE_PRODUCT_SUITE_ITEM:
      return { ...state, productSuiteItem: action.payload }
    case actionTypes.DELETE_PRODUCT_SUITE_ITEM:
      return state

    case actionTypes.PRODUCT_SUITE_ITEM_CREATED:
      return { ...state, productSuiteItems: [...state.productSuiteItems, action.payload] }
    case actionTypes.PRODUCT_SUITE_ITEMS_LOADED:
      return { ...state, productSuiteItems: action.payload }
    case actionTypes.PRODUCT_SUITE_ITEM_LOADED:
      return { ...state, productSuiteItem: action.payload }
    case actionTypes.PRODUCT_SUITE_ITEM_UPDATED:
      return {
        ...state,
        productSuiteItem: action.payload,
        productSuiteItems: state.productSuiteItems.map(item => item.id === +action.payload.id ? action.payload : item)
      }
    case actionTypes.PRODUCT_SUITE_ITEM_DELETED:
      return { ...state, productSuiteItems: state.productSuiteItems.filter(item => item.id !== action.payload) }

    case actionTypes.INSERT_EMPTY_ROW:
      return {
        ...state,
        productSuiteItems: insertEmptyRow(state.productSuiteItems, action.payload, uuidv4())
      }
    case actionTypes.DELETE_ROW: {
      const filterd = state.productSuiteItems.filter(item => item.position !== action.payload)
      if (filterd.length === 0) {
        return { ...state, productSuiteItems: [{ position: 1, id: uuidv4() }] }
      } else {
        return { ...state, productSuiteItems: filterd.map((item, index) => ({ ...item, position: index + 1 })) }
      }
    }
    case actionTypes.INSERT_ROWS: {
      const nodes = action.payload.rows
      return {
        ...state,
        productSuiteItems: insertRows(
          state.productSuiteItems,
          nodes.map(node => ({
            ...node,
            data: {
              ...node.data,
              product_id: node.data.id,
              qty: 0,
              price: 0,
              id: uuidv4()
            }
          })),
          action.payload.position)
      }
    }
    default:
      return state
  }
}

// Action Creators
export const actions = {
  createProductSuiteItem: (productSuiteItem, setSubmitting) => ({ type: actionTypes.CREATE_PRODUCT_SUITE_ITEM, payload: { productSuiteItem, setSubmitting } }),
  fetchProductSuiteItems: () => ({ type: actionTypes.FETCH_PRODUCT_SUITE_ITEMS }),
  fetchProductSuiteItem: (id) => ({ type: actionTypes.FETCH_PRODUCT_SUITE_ITEM, payload: id }),
  updateProductSuiteItem: (productSuiteItem, setSubmitting) => ({ type: actionTypes.UPADE_PRODUCT_SUITE_ITEM, payload: { productSuiteItem, setSubmitting } }),
  deleteProductSuiteItem: id => ({ type: actionTypes.DELETE_PRODUCT_SUITE_ITEM, payload: id }),
  productSuiteItemCreated: (productSuiteItem) => ({ type: actionTypes.PRODUCT_SUITE_ITEM_CREATED, payload: productSuiteItem }),
  productSuiteItemsLoaded: (productSuiteItems) => ({ type: actionTypes.PRODUCT_SUITE_ITEMS_LOADED, payload: productSuiteItems }),
  productSuiteItemLoaded: (productSuiteItem) => ({ type: actionTypes.PRODUCT_SUITE_ITEM_LOADED, payload: productSuiteItem }),
  productSuiteItemUpdated: (productSuiteItem) => ({ type: actionTypes.PRODUCT_SUITE_ITEM_UPDATED, payload: productSuiteItem }),
  productSuiteItemDeleted: id => ({ type: actionTypes.PRODUCT_SUITE_ITEM_DELETED, payload: id }),
  inertEmptyRow: position => ({ type: actionTypes.INSERT_EMPTY_ROW, payload: position }),
  deleteRow: position => ({ type: actionTypes.DELETE_ROW, payload: position }),
  inertRows: (position, rows) => ({ type: actionTypes.INSERT_ROWS, payload: { position, rows } })

}

// Saga
export function * saga () {
  yield takeLatest(actionTypes.CREATE_PRODUCT_SUITE_ITEM, function * createProductSuiteItemSaga (action) {
    const { productSuiteItem, setSubmitting } = action.payload
    try {
      const result = yield call(apiClient.post, 'product_suite_items', productSuiteItem)
      yield put(actions.productSuiteItemCreated(result.data.data))
      notifySuccess('新增成功')
    } catch (e) {
      notifyError(e.response ? e.response.statusText : e.message)
    } finally {
      setSubmitting(false)
    }
  })

  yield takeLatest(actionTypes.FETCH_PRODUCT_SUITE_ITEMS, function * fetchProductSuiteItemsSaga () {
    try {
      const result = yield call(apiClient.get, 'product_suite_items')
      yield put(actions.productSuiteItemsLoaded(result.data.data))
    } catch (e) {
      notifyError(e.response ? e.response.statusText : e.message)
    }
  })

  yield takeLatest(actionTypes.FETCH_PRODUCT_SUITE_ITEM, function * fetchProductSuiteItemSaga (action) {
    try {
      const id = action.payload
      const result = yield call(apiClient.get, `product_suite_items/${id}`)
      yield put(actions.productSuiteItemLoaded(result.data.data))
    } catch (e) {
      notifyError(e.response ? e.response.statusText : e.message)
    }
  })

  yield takeLatest(actionTypes.UPADE_PRODUCT_SUITE_ITEM, function * updateProductSuiteItemSaga (action) {
    const { productSuiteItem, setSubmitting } = action.payload
    try {
      const result = yield call(apiClient.put, `product_suite_items/${productSuiteItem.id}`, productSuiteItem)
      yield put(actions.productSuiteItemUpdated(result.data.data))
      notifySuccess('更新成功')
    } catch (e) {
      notifyError(e.response ? e.response.statusText : e.message)
    } finally {
      setSubmitting(false)
    }
  })

  yield takeLatest(actionTypes.DELETE_PRODUCT_SUITE_ITEM, function * deleteProductSuiteItemSaga (action) {
    try {
      const id = action.payload
      yield fork(apiClient.delete, `product_suite_items/${id}`)
      yield put(actions.productSuiteItemDeleted(id))
      notifySuccess('刪除成功')
    } catch (e) {
      notifyError(e.response ? e.response.statusText : e.message)
    }
  })

  yield takeLatest(actionTypes.INSERT_EMPTY_ROW, function * insertEmptyRowSaga (action) {
    try {
      const { productSuiteItems } = yield select(state => state.productSuiteItems)
      yield put(suiteFolderDuck.actions.updateSelectedSuiteFolderItems(productSuiteItems))
    } catch (e) {
      notifyError(e.response ? e.response.statusText : e.message)
    }
  })

  yield takeLatest(actionTypes.DELETE_ROW, function * insertEmptyRowSaga (action) {
    try {
      const { productSuiteItems } = yield select(state => state.productSuiteItems)
      yield put(suiteFolderDuck.actions.updateSelectedSuiteFolderItems(productSuiteItems))
    } catch (e) {
      notifyError(e.response ? e.response.statusText : e.message)
    }
  })

  yield takeLatest(actionTypes.INSERT_ROWS, function * insertEmptyRowSaga (action) {
    try {
      const { productSuiteItems } = yield select(state => state.productSuiteItems)
      yield put(suiteFolderDuck.actions.updateSelectedSuiteFolderItems(productSuiteItems))
    } catch (e) {
      notifyError(e.response ? e.response.statusText : e.message)
    }
  })
}
